import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

export class ParamColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n, recommendationType }) {
    const title = newI18n.getString(_TL_('Param'));

    super({
      name: 'param',
      property: 'Opportunities/Param',
      title,
      bodyClasses: ['grid-column-param'],
      colClasses: ['col-normalText'],
      helpId: 'Pop_BA_Recommendations_KeywordParameters',
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.newI18n = newI18n;
    this.recommendationType = recommendationType;
  }

  template({
    value: {
      RawSuggParam1,
      RawSuggParam2,
      RawSuggParam3,
    },
  }) {
    const { newI18n } = this;
    if (!_.isEmpty(RawSuggParam1)) {
      return newI18n.getString(_TL_('Param1'));
    } else if (!_.isEmpty(RawSuggParam2)) {
      return newI18n.getString(_TL_('Param2'));
    } else if (!_.isEmpty(RawSuggParam3)) {
      return newI18n.getString(_TL_('Param3'));
    }
    return '';
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
